import axios from "axios";

const BASE_API_GATEWAY_URL = APP_URLS?.base_api_gateway_url

const ENDPOINT = "web-service/apig/sessions/otp";

const COMMON_HEADERS = {
  "X-CSRF-Token": document
    .querySelector("meta[name=csrf-token]")
    ?.getAttribute("content"),
  "X-Requested-With": "XMLHttpRequest",
  "Content-type": "application/json; charset=UTF-8",
};

const sendOTP = async (email: string): Promise<void> => {
  return await axios.post(
    `${BASE_API_GATEWAY_URL}/${ENDPOINT}/create`,
    { email },
    {
      headers: COMMON_HEADERS,
      withCredentials: true,
    }
  );
};

const resendOTP = async (email: string, id: string): Promise<void> => {
  return await axios.post(
    `${BASE_API_GATEWAY_URL}/${ENDPOINT}/resend`,
    { id, email },
    {
      headers: COMMON_HEADERS,
      withCredentials: true,
    }
  );
};

const verifyOTP = async (id: string, email: string, otp: string, user_type: string, referral_type: string, referrer_page: string): Promise<void> => {
  return await axios.post(
    `/${ENDPOINT}/verify`,
    { id, email, otp, user_type, referral_type, referrer_page },
    {
      headers: COMMON_HEADERS,
      withCredentials: true,
    }
  );
};

export const APIS = {
  sendOTP,
  resendOTP,
  verifyOTP
};
